import { Component } from 'react';
import PropTypes from 'prop-types';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { Image } from 'foundations-components/transitional/components/Image';
import { View } from 'foundations-components/components/View';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View as FoundationsView } from 'foundations-components/transitional/components/View';
import { EllipsesIcon, SprocketIcon } from 'foundations-assets';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { MaxWidthContainer } from './MaxWidthContainer';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class AuthorizeHeader extends Component {
  renderImages() {
    const hubspotIcon = /*#__PURE__*/_jsx(SprocketIcon, {
      color: "fill-brand-default",
      size: "1200"
    });
    if (this.props.providerIconUrl) {
      return /*#__PURE__*/_jsxs(Flex, {
        flexDirection: "row",
        alignItems: "center",
        gap: "400",
        children: [/*#__PURE__*/_jsx(Image, {
          src: this.props.providerIconUrl,
          width: 100,
          height: 100,
          objectFit: "contain",
          responsive: false
        }), /*#__PURE__*/_jsx(EllipsesIcon, {
          color: "fill-primary-default",
          size: "900"
        }), hubspotIcon]
      });
    } else {
      return hubspotIcon;
    }
  }
  render() {
    const {
      providerName
    } = this.props;
    return /*#__PURE__*/_jsxs(FoundationsView, {
      paddingInline: "200",
      as: "div",
      children: [/*#__PURE__*/_jsx(View, {
        inlineSize: "100%",
        marginBlock: "400",
        children: /*#__PURE__*/_jsx(Flex, {
          justifyContent: "center",
          children: this.renderImages()
        })
      }), /*#__PURE__*/_jsx(MaxWidthContainer, {
        children: providerName.length > 30 ? /*#__PURE__*/_jsx(Text, {
          as: "h2",
          textAlign: "center",
          "data-test-id": "authorize-header-text",
          children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
            message: "oauth.authorization.connecting_jsx",
            elements: {
              TruncateString,
              b: 'b'
            },
            options: {
              provider: providerName
            }
          })
        }) : /*#__PURE__*/_jsx(Text, {
          as: "h2",
          textAlign: "center",
          "data-test-id": "authorize-header-text",
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "oauth.authorization.connecting",
            options: {
              provider: providerName
            }
          })
        })
      })]
    });
  }
}
AuthorizeHeader.propTypes = {
  providerIconUrl: PropTypes.string,
  providerName: PropTypes.string.isRequired
};
export default AuthorizeHeader;